import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { RHFInputText } from '../../../../../../packages/react-hook-form';
import { MaskedSwedishSsnInput } from '../../../../../input/components';
import { MaskedSwedishPostNumberInput } from '../../../../../input/components/masked-swedish-postnumber-input';
import { RHFInputTextNullable } from '../../../../../../packages/react-hook-form/input/input-text-nullable';
import styles from './styles.module.scss';

export const AuditorCompanyInput = ({
  sellAuditor = false,
}: {
  sellAuditor?: boolean;
}) => {
  const createName = (name: string) => `auditorFirm.${name}`;

  const { unregister, control, errors } = useFormContext();

  useEffect(
    () => () => {
      unregister(
        [
          'organizationName',
          'organizationNumber',
          'organizationAddress',
          'organizationPostalCode',
          'organizationCity',
        ].map((key) => createName(key)),
      );
    },
    [unregister],
  );

  return (
    <div className={styles.inputGroup}>
      <RHFInputText
        required
        control={control}
        errors={errors}
        name={createName('organizationName')}
        label="Revisionsbolagets namn"
      />

      <RHFInputText
        required
        control={control}
        errors={errors}
        name={createName('organizationNumber')}
        label="Organisationsnummer"
        InputProps={{ inputComponent: MaskedSwedishSsnInput }}
      />

      <RHFInputTextNullable
        required={!sellAuditor}
        control={control}
        errors={errors}
        name={createName('organizationAddress')}
        label="Utdelningsadress"
      />

      <RHFInputTextNullable
        required={!sellAuditor}
        control={control}
        errors={errors}
        name={createName('organizationPostalCode')}
        label="Postnummer"
        InputProps={{ inputComponent: MaskedSwedishPostNumberInput }}
      />

      <RHFInputTextNullable
        required={!sellAuditor}
        control={control}
        errors={errors}
        name={createName('organizationCity')}
        label="Ort"
      />
    </div>
  );
};
